"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var _LanguageProvider = require("../../common/LanguageProvider");
var useProductsBySkus = function useProductsBySkus(skus, pageSize, fetchedProductsBySkus) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([skus, pageSize, language, "useProductsBySkus"], function (skus, pageSize, language) {
    return (0, _fetcher["default"])({
      skus: skus,
      pageSize: pageSize,
      language: language
    });
  }, {
    initialData: fetchedProductsBySkus
  });
};
var _default = useProductsBySkus;
exports["default"] = _default;